import { GridColDef } from '@mui/x-data-grid-pro';
import { YtdByCustomerRecord, YtdByServiceRecord } from '@api/Trinium/Endpoints/Settlements/types';

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

const currencyColumn = {
  type: 'number' as const,
  valueFormatter: (value: number | undefined) => (value != null ? currencyFormatter.format(value) : '')
};

export const byCustomerColumns: GridColDef<YtdByCustomerRecord>[] = [
  { field: 'customer', headerName: 'Customer', minWidth: 180, flex: 1 },
  { field: 'amount', headerName: 'Amount', width: 140, ...currencyColumn }
];

export const byServiceColumns: GridColDef<YtdByServiceRecord>[] = [
  { field: 'serviceDescription', headerName: 'Service Description', minWidth: 180, flex: 1 },
  { field: 'amount', headerName: 'Amount', width: 140, ...currencyColumn }
];
